import React, { useState } from 'react';
import { Info } from 'lucide-react';

const InfoTooltip = ({ text, position = 'top', align = 'center' }) => {
  const [show, setShow] = useState(false);

  const isBottom = position === 'bottom';

  return (
    <div 
      style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', marginLeft: '0.5rem' }}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      onClick={() => setShow(!show)}
    >
      <Info size={16} color="var(--text-secondary)" style={{ cursor: 'pointer', transition: 'color 0.2s' }} />
      
      {show && (
        <div style={{
          position: 'absolute',
          bottom: isBottom ? 'auto' : '100%',
          top: isBottom ? '100%' : 'auto',
          left: align === 'center' ? '50%' : align === 'left' ? '0' : 'auto',
          right: align === 'right' ? '0' : 'auto',
          transform: `translateX(${align === 'center' ? '-50%' : '0'}) translateY(${isBottom ? '8px' : '-8px'})`,
          width: 'max-content',
          maxWidth: '300px',
          backgroundColor: 'rgba(15, 23, 42, 0.95)',
          backdropFilter: 'blur(8px)',
          border: '1px solid var(--glass-border)',
          color: 'var(--text-primary)',
          fontSize: '0.8rem',
          fontWeight: 'normal',
          padding: '0.6rem 0.8rem',
          borderRadius: '8px',
          boxShadow: '0 10px 25px rgba(0,0,0,0.5)',
          zIndex: 1000,
          pointerEvents: 'none',
          animation: 'fadeIn 0.2s ease-out forwards',
          whiteSpace: 'pre-wrap',
          lineHeight: '1.4',
          textAlign: 'left',
          textTransform: 'none'
        }}>
          {text}
          <div style={{
            position: 'absolute',
            bottom: isBottom ? 'auto' : '-6px',
            top: isBottom ? '-6px' : 'auto',
            left: align === 'center' ? '50%' : align === 'left' ? '12px' : 'auto',
            right: align === 'right' ? '12px' : 'auto',
            transform: `translateX(${align === 'center' ? '-50%' : '0'}) rotate(45deg)`,
            width: '12px',
            height: '12px',
            backgroundColor: 'rgba(15, 23, 42, 0.95)',
            borderRight: isBottom ? 'none' : '1px solid var(--glass-border)',
            borderBottom: isBottom ? 'none' : '1px solid var(--glass-border)',
            borderLeft: isBottom ? '1px solid var(--glass-border)' : 'none',
            borderTop: isBottom ? '1px solid var(--glass-border)' : 'none'
          }}></div>
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;
